<div class="relative flex-shrink-0">

  <!-- Trigger -->
  <button type="button" (click)="toggle()"
    class="flex items-center gap-2 bg-white border border-stone-200 text-stone-700 text-sm rounded-lg px-3 py-2 min-w-[160px] max-w-[220px] outline-none focus:border-primary-300 focus:ring-2 focus:ring-primary-100 transition-all duration-200 hover:border-stone-300">

    @if (selected()) {
      <div class="w-6 h-6 rounded-full bg-stone-100 flex items-center justify-center overflow-hidden flex-shrink-0">
        @if (selected()!.club_logo_url) {
          <img [src]="selected()!.club_logo_url" class="w-full h-full object-cover" alt="" />
        } @else {
          <span class="text-[10px] font-bold text-stone-500">{{ initials(selected()!) }}</span>
        }
      </div>
      <span class="truncate flex-1 text-left font-medium">{{ label(selected()!) }}</span>
    } @else {
      <svg class="w-4 h-4 text-stone-400 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
        <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"/>
      </svg>
      <span class="truncate flex-1 text-left text-stone-400">Tous les clubs</span>
    }

    <svg class="w-4 h-4 text-stone-400 flex-shrink-0 transition-transform duration-200" [class.rotate-180]="open()" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7"/>
    </svg>
  </button>

  <!-- Dropdown panel -->
  @if (open()) {
    <div class="absolute top-full mt-1 left-0 z-50 w-72 bg-white border border-stone-200 rounded-xl shadow-lg overflow-hidden">

      <!-- Search -->
      <div class="p-2 border-b border-stone-100">
        <div class="relative">
          <svg class="absolute left-3 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-stone-400 pointer-events-none" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
            <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"/>
          </svg>
          <input type="text" placeholder="Rechercher un club…"
            class="w-full bg-stone-50 border border-stone-200 rounded-lg pl-8 pr-3 py-1.5 text-xs text-stone-700 placeholder-stone-400 outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-100"
            [value]="search()" (input)="search.set($any($event.target).value)" />
        </div>
      </div>

      <!-- Options list -->
      <div class="max-h-60 overflow-y-auto">

        <!-- All clubs option -->
        <button type="button" (click)="select(0)"
          class="w-full flex items-center gap-2.5 px-3 py-2.5 text-sm hover:bg-stone-50 transition-colors duration-150 text-left"
          [class.bg-primary-50]="value === 0">
          <div class="w-7 h-7 rounded-full bg-stone-100 flex items-center justify-center flex-shrink-0">
            <svg class="w-3.5 h-3.5 text-stone-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"/>
            </svg>
          </div>
          <span class="text-stone-500 font-medium">Tous les clubs</span>
          @if (value === 0) {
            <svg class="w-4 h-4 text-primary-500 ml-auto flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
              <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
            </svg>
          }
        </button>

        @for (c of filtered(); track c.club_id) {
          <button type="button" (click)="select(c.club_id)"
            class="w-full flex items-center gap-2.5 px-3 py-2.5 text-sm hover:bg-stone-50 transition-colors duration-150 text-left"
            [class.bg-primary-50]="value === c.club_id">
            <div class="w-7 h-7 rounded-full bg-stone-100 flex items-center justify-center overflow-hidden flex-shrink-0">
              @if (c.club_logo_url) {
                <img [src]="c.club_logo_url" class="w-full h-full object-cover" alt="" />
              } @else {
                <span class="text-[10px] font-bold text-stone-500">{{ initials(c) }}</span>
              }
            </div>
            <div class="flex flex-col min-w-0 flex-1">
              <span class="font-medium text-stone-800 text-xs truncate">{{ c.club_name }}</span>
              <span class="text-[10px] text-stone-400 font-mono">{{ c.club_short_code || c.club_code }}</span>
            </div>
            @if (value === c.club_id) {
              <svg class="w-4 h-4 text-primary-500 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2.5">
                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5"/>
              </svg>
            }
          </button>
        }

        @if (filtered().length === 0) {
          <p class="px-4 py-6 text-center text-xs text-stone-400">Aucun club trouvé</p>
        }
      </div>
    </div>
  }
</div>
